import { render, staticRenderFns } from "./addAccount.vue?vue&type=template&id=82f7492a"
import script from "./addAccount.vue?vue&type=script&lang=ts"
export * from "./addAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports